import React from 'react';
import { Button } from 'seagull';
import { StepPage } from "../../components/StepPage";
import { ReviewServices } from "../ReviewServices/ReviewServices";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
export default function ReviewServicesStep(_ref) {
  let {
    selectedBundleID,
    selectedOptionalServices,
    onDone,
    onBack,
    setSelectedOptionalServices
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.reviewServices, relationship),
    showLearnMore: true,
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'review-services-step-next-btn',
      onClick: () => {
        onDone();
      }
    }, 'Next'),
    errorTestid: "review-services-step-next-error",
    onBackBtnClick: onBack,
    backBtnTestid: (relationship.isSample ? 'test-agreement-' : '') + 'review-services-step-back-btn',
    testid: "review-services-step"
  }, /*#__PURE__*/React.createElement(ReviewServices, {
    relationship: relationship,
    selectedBundleID: selectedBundleID,
    selectedOptionalServices: selectedOptionalServices,
    setSelectedOptionalServices: setSelectedOptionalServices
  }));
}